import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link, NavLink } from 'react-router-dom';
import { IntrigrationLeftSec } from '../components/intrigrationLeftSec';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from "react-scroll-to-top";
import { useState } from 'react';
import config from '../Config';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Modal from 'react-bootstrap/Modal';

export const IssuingWebhook=() =>
{
  const [ showSix, setShowSix ]=useState( false );

  const exampleCodeText_1= `{
  "event": "card-transaction-events",
  "id": "12ce86h0-1234-1234-abcd-6a7fd1e14321",
  "token": "webhook's encrypted token",
  "customer": {
    "name": "TCB PAY LTD",
    "accountName": "TCB PAY LTD"
  },
  "elements": [
    {
      "pos": {
        "entryType": 81,
        "acceptorId": "FNTQDANMUWY4321",
        "acceptLocation": "TCB PAY LTD 310-4697070 NV",
        "entryDescription": "ECOMMERCE"
      },
      "card": {
        "id": "Card's unique ID",
        "bin": "556735",
        "cardLastFour": "7298",
        "employeeNumber": "5494588454",
        "userDefinedFields": [],
        "cardHolderLastName": "Diaz",
        "cardHolderFirstName": "Roberto"
      },
      "type": "REVERSAL",
      "merchant": {
        "mcc": "7399"
      },
      "acquirerId": "019517",
      "approvalCode": 985644,
      "postedAmount": 0,
      "reversalFlag": "Y",
      "idMatchNumber": "123J23434",
      "preAuthAmount": 6,
      "expirationDate": "2708",
      "transactionTime": "2026-05-15 05:47:07.792555",
      "authorizationTime": "2026-05-15 05:47:07.770961",
      "approximateReceiveCount": "1"
    }
  ],
  "metadata": {
    "change": "card-transaction",
    "changeTime": "2026-05-15 06:49:23.086664",
    "changeType": "UPDATE"
  },
  "creationTime": "2026-05-15 05:49:32.802564"
}`;

  const exampleCodeText_2= `{
  "event": "card-transaction-events",
  "id": "128gy9bf-1234-1234-1234-431de6d88f22",
  "token": "webhook's encrypted token",
  "customer": {
    "name": "TCB PAY LTD",
    "accountName": "TCB PAY LTD"
  },
  "elements": [
    {
      "pos": {
        "entryType": 5,
        "acceptorId": "080752000004321",
        "acceptLocation": "TCB PAY LTD 310-4697070 NV",
        "entryDescription": "ECOMMERCE"
      },
      "card": {
        "id": "Card's unique ID",
        "bin": "556735",
        "cardLastFour": "7298",
        "employeeNumber": "9713446024",
        "userDefinedFields": [],
        "cardHolderLastName": "Diaz",
        "cardHolderFirstName": "Roberto"
      },
      "type": "PRE_AUTHORIZATION",
      "merchant": {
        "mcc": "7399"
      },
      "acquirerId": "012553",
      "approvalCode": 930854,
      "postedAmount": 0,
      "reversalFlag": "N",
      "idMatchNumber": "123J23434",
      "preAuthAmount": 11,
      "expirationDate": "2708",
      "transactionTime": "2026-05-15 21:34:38.100173",
      "authorizationTime": "2026-05-15 21:34:38.079801",
      "approximateReceiveCount": "34"
    }
  ],
  "metadata": {
    "change": "card-transaction",
    "changeTime": "2026-05-15 22:34:38.231401",
    "changeType": "UPDATE"
  },
  "creationTime": "2026-05-15 21:45:42.343066"
}`;

  const exampleCodeText_3= `{
  "event": "card-transaction-events",
  "id": "129af97f-1234-1234-1234-64f9f6bb0149",
  "token": "webhook's encrypted token",
  "customer": {
    "name": "TCB PAY LTD",
    "accountName": "TCB PAY LTD"
  },
  "elements": [
    {
      "arn": "55432812341209247123456",
      "ird": "69",
      "pos": {
        "entryType": 7,
        "acceptorId": "324000000014321",
        "acceptLocation": "TCB PAY LTD 310-4697070 NV",
        "entryDescription": "UNKNOWN"
      },
      "card": {
        "id": "Card's unique ID",
        "bin": "556735",
        "cardLastFour": "7298",
        "employeeNumber": "380208200",
        "userDefinedFields": [],
        "cardHolderLastName": "Diaz",
        "cardHolderFirstName": "Roberto"
      },
      "type": "POST",
      "merchant": {
        "mcc": "7399",
        "name": "TCB PAY LTD",
        "address": {
          "zip": "89074",
          "city": "310-4697070",
          "state": "NV",
          "country": "USA",
          "addressLine1": "433 PLAZA REAL SUITE 275"
        }
      },
      "acquirerId": "003286",
      "postedDate": "2026-02-01",
      "authTraceId": "MCFAIGUNO0130",
      "approvalCode": 947021,
      "postedAmount": 12.4,
      "reversalFlag": "N",
      "idMatchNumber": "123K2349F",
      "preAuthAmount": 12.4,
      "expirationDate": "2708",
      "transactionTime": "2026-05-15 12:04:28.910630",
      "authorizationTime": "2026-05-15 14:12:00.893604",
      "postControlNumber": "152254",
      "approximateReceiveCount": "1"
    }
  ],
  "metadata": {
    "change": "card-transaction",
    "changeTime": "2026-05-15 13:04:28.959874",
    "changeType": "UPDATE"
  },
  "creationTime": "2026-05-15 12:04:31.406799"
}`;

  const exampleCodeText_4= `{
  "event": "card-transaction-events",
  "id": "12a165e4-1234-1234-1234-6308de853e75",
  "token": "webhook's encrypted token",
  "customer": {
    "name": "TCB PAY LTD",
    "accountName": "TCB PAY LTD"
  },
  "elements": [
    {
      "pos": {
        "entryType": 10,
        "acceptorId": "248750000104321",
        "acceptLocation": "TCB PAY LTD 310-4697070 NV",
        "entryDescription": "UNKNOWN"
      },
      "card": {
        "id": "Card's unique ID",
        "bin": "556735",
        "cardLastFour": "7298",
        "employeeNumber": "5598909226",
        "userDefinedFields": [],
        "cardHolderLastName": "Diaz",
        "cardHolderFirstName": "Roberto"
      },
      "type": "DECLINE",
      "merchant": {
        "mcc": "7399"
      },
      "acquirerId": "003286",
      "postedDate": "2026-05-15",
      "authTraceId": "MCFV7REYK0201",
      "declineCode": 787,
      "approvalCode": 0,
      "postedAmount": 0,
      "reversalFlag": "N",
      "idMatchNumber": "123K234PV",
      "preAuthAmount": 7.49,
      "declineMessage": "CYCLE AMOUNT LIMIT EXCEEDED",
      "expirationDate": "2708",
      "transactionTime": "2026-05-15 16:05:35.153847",
      "correctiveAction": "VERIFY AMOUNT AND ADJUST LIMIT",
      "authorizationTime": "2026-05-15 16:05:35.144327",
      "postControlNumber": "0",
      "approximateReceiveCount": "1"
    }
  ],
  "metadata": {
    "change": "card-transaction",
    "changeTime": "2026-05-15 17:05:35.197108",
    "changeType": "UPDATE"
  },
  "creationTime": "2026-05-15 16:05:37.184992"
}`;

  const exampleCodeText_5= `{
  "event": "card-transaction-events",
  "id": "12b33ee8-1234-1234-1234-5bd659ba73dd",
  "token": "webhook's encrypted token",
  "customer": {
    "name": "TCB PAY LTD",
    "accountName": "TCB PAY LTD"
  },
  "elements": [
    {
      "arn": "85306512343900019123456",
      "ird": "41",
      "pos": {
        "entryType": 10,
        "acceptorId": "180000032474321",
        "acceptLocation": "TCB PAY LTD 310-4697070 NV",
        "entryDescription": "UNKNOWN"
      },
      "card": {
        "id": "Card's unique ID",
        "bin": "556735",
        "cardLastFour": "7298",
        "employeeNumber": "35496676543234",
        "userDefinedFields": [],
        "cardHolderLastName": "Diaz",
        "cardHolderFirstName": "Roberto"
      },
      "type": "CREDIT",
      "merchant": {
        "mcc": "7399",
        "name": "TCB PAY LTD",
        "address": {
          "zip": "89074",
          "city": "310-4697070",
          "state": "NV",
          "country": "USA",
          "addressLine1": "433 PLAZA REAL SUITE 275"
        }
      },
      "acquirerId": "004084",
      "approvalCode": 0,
      "postedAmount": -2.45,
      "reversalFlag": "C",
      "idMatchNumber": "123J234NM",
      "preAuthAmount": -2.45,
      "expirationDate": "2708",
      "transactionTime": "2026-05-15 02:59:47.915198",
      "authorizationTime": "2026-05-15 02:59:47.913403"
    }
  ],
  "metadata": {
    "change": "card-transaction",
    "changeTime": "2026-05-15 02:59:47.915198",
    "changeType": "UPDATE"
  },
  "creationTime": "2026-05-15 02:59:52.467132"
}`;

  const exampleCodeText_6= `{
  "event": "card-transaction-events",
  "id": "123cc7be-1234-1234-1234-685123acca41",
  "token": "webhook's encrypted token",
  "customer": {
    "name": "TCB PAY LTD",
    "accountName": "TCB PAY LTD"
  },
  "elements": [
    {
      "pos": {
        "entryType": 81,
        "acceptorId": "A00966281004321",
        "acceptLocation": "TCB PAY LTD 310-4697070 NV",
        "entryDescription": "ECOMMERCE"
      },
      "card": {
        "id": "Card's unique ID",
        "bin": "556735",
        "cardLastFour": "7298",
        "employeeNumber": "430555871888968",
        "userDefinedFields": [],
        "cardHolderLastName": "Diaz",
        "cardHolderFirstName": "Roberto"
      },
      "type": "AUTHORIZATION",
      "merchant": {
        "mcc": "7399"
      },
      "acquirerId": "020491",
      "postedDate": "2026-05-15",
      "authTraceId": "MCFIBH62S0223",
      "approvalCode": 950148,
      "postedAmount": 0,
      "reversalFlag": "N",
      "idMatchNumber": "123K12349T",
      "preAuthAmount": 60,
      "expirationDate": "2708",
      "transactionTime": "2026-05-15 21:12:01.616496",
      "authorizationTime": "2026-05-15 21:12:01.600992",
      "postControlNumber": "0",
      "approximateReceiveCount": "1"
    }
  ],
  "metadata": {
    "change": "card-transaction",
    "changeTime": "2026-05-15 22:12:01.632235",
    "changeType": "UPDATE"
  },
  "creationTime": "2026-05-15 21:12:03.709709"
}`;


  const onCopy=React.useCallback( ( id: number ) =>
  {
    const element=document.getElementById( "myTooltip"+id );
    if ( element )
    {
      element.classList.add( "show" );
      const intervalId=setInterval( () =>
      {
        element.classList.remove( "show" );
        clearInterval( intervalId );
      }, 2000 );
    }
  }, [] );

  return (
    <>
      <section className="credit-api-main">
        <img src={ `${ config.siteBaseUrl }/assets/imgs/our-integrations-bg.svg` } alt="" className='apibg' />
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <IntrigrationLeftSec />
            </div>
            <div className="col-lg-9">
              <div className="creadit-api-upper-wrapper">
                <Link to="/integrations" className='apidetail-btn'><FontAwesomeIcon icon={ faArrowRight } /> Return to Integrations page</Link>
                <div className="api-menu-item-title"><h1>Transaction Event Webhook</h1></div>

                <div className="api-menu-item-wrapper mb-40">
                  <h2>Card Transaction Payload</h2>
                  <p>The generated card transaction payload includes customer, metadata, transaction, card, merchant, POS, and encrypted token information.</p>
                </div>

                <div className='api-menu-item-title'>
                  <h2>Card Transaction Payload Properties</h2>
                </div>

                <div className="api-table">
                  <h5>Transaction Payload Descriptions</h5>
                  <div className="table-responsive mb-20">
                    <table summary="The table describes the card transaction webhook payload properties." className="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={ { width: '180px' } }>Element Name</th>
                          <th style={ { width: '120px' } }>DataType</th>
                          <th style={ { width: '480px' } }>Comments/Example Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Event</td>
                          <td>string</td>
                          <td className="text-start">The event that has been triggered. Example: "card-transaction-events"</td>
                        </tr>
                        <tr>
                          <td>Id</td>
                          <td>String</td>
                          <td className="text-start">A unique ID associated with the triggered event.</td>
                        </tr>
                        <tr>
                          <td>token</td>
                          <td>String</td>
                          <td className="text-start">
                            Encrypted token value supplied with the transaction payload. This value must be processed using the applicable public key / agreed key flow.<br />
                            (username|card.ID|creationTime : These values are being encrypted with private key and public key for decryption will be shared by TCBPAY.
                          </td>
                        </tr>
                        <tr>
                          <td>creationTime</td>
                          <td>String</td>
                          <td className="text-start">The date and time the event was created.</td>
                        </tr>
                        <tr>
                          <td>Customer</td>
                          <td>Object</td>
                          <td className="text-start">Customer object.</td>
                        </tr>
                        <tr>
                          <td>name</td>
                          <td>String</td>
                          <td className="text-start">Customer name.</td>
                        </tr>
                        <tr>
                          <td>accountName</td>
                          <td>String</td>
                          <td className="text-start">Customer account name.</td>
                        </tr>
                        <tr>
                          <td>Metadata</td>
                          <td>Object</td>
                          <td className="text-start">Metadata object.</td>
                        </tr>
                        <tr>
                          <td>change</td>
                          <td>String</td>
                          <td className="text-start">The field that has been changed in the payload.</td>
                        </tr>
                        <tr>
                          <td>changeType</td>
                          <td>String</td>
                          <td className="text-start">The type of change committed to the system. The change type can be INSERT or UPDATE depending on the action. INSERT is returned when a field has been added. UPDATE is returned when a field has been modified.</td>
                        </tr>
                        <tr>
                          <td>changeTime</td>
                          <td>String</td>
                          <td className="text-start">The date and time the change was committed to the system.</td>
                        </tr>
                        <tr>
                          <td>elements</td>
                          <td>Array</td>
                          <td className="text-start">Array containing card transaction object(s).</td>
                        </tr>
                        <tr>
                          <td>type</td>
                          <td>String</td>
                          <td className="text-start">Transaction type. Example: REVERSAL, AUTHORIZATION, CREDIT, POST, DECLINE, PRE_AUTHORIZATION, FORCE POST, Declined, Authorized</td>
                        </tr>
                        <tr>
                          <td>approvalCode</td>
                          <td>integer</td>
                          <td className="text-start">Approval code associated with the authorization.</td>
                        </tr>
                        <tr>
                          <td>preAuthAmount</td>
                          <td>Number</td>
                          <td className="text-start">Pre-authorization amount.</td>
                        </tr>
                        <tr>
                          <td>postedAmount</td>
                          <td>Number</td>
                          <td className="text-start">Posted transaction amount.</td>
                        </tr>
                        <tr>
                          <td>idMatchNumber</td>
                          <td>String</td>
                          <td className="text-start">Transaction matching identifier.</td>
                        </tr>
                        <tr>
                          <td>reversalFlag</td>
                          <td>String</td>
                          <td className="text-start">
                            N = No reversal<br />
                            Y = Full reversal of authorized transaction<br />
                            P = Partial reversal (adjustment of authorized transaction)<br />
                            X = Expiration of authorized transaction<br />
                            R = Reversal for all or a portion of a posted amount<br />
                            C = Credit for all or a portion of a posted amount<br />
                            Or blank
                          </td>
                        </tr>
                        <tr>
                          <td>declineCode</td>
                          <td>Integer</td>
                          <td className="text-start">Decline code, if applicable.</td>
                        </tr>
                        <tr>
                          <td>declineMessage</td>
                          <td>string</td>
                          <td className="text-start">Decline message, if applicable.</td>
                        </tr>
                        <tr>
                          <td>correctiveAction</td>
                          <td>String</td>
                          <td className="text-start">Corrective action, if applicable.</td>
                        </tr>
                        <tr>
                          <td>transactionTime</td>
                          <td>String</td>
                          <td className="text-start">Date and time of the transaction.</td>
                        </tr>
                        <tr>
                          <td>authorizationTime</td>
                          <td>String</td>
                          <td className="text-start">Date and time of authorization.</td>
                        </tr>
                        <tr>
                          <td>expirationDate</td>
                          <td>String</td>
                          <td className="text-start">Card expiration date in MMYY format.</td>
                        </tr>
                        <tr>
                          <td>acquirerId</td>
                          <td>String</td>
                          <td className="text-start">Acquirer ID.</td>
                        </tr>
                        <tr>
                          <td>approximateReceiveCount</td>
                          <td>String</td>
                          <td className="text-start">Approximate receive count value.</td>
                        </tr>
                        <tr>
                          <td>authTraceId</td>
                          <td>String</td>
                          <td className="text-start">Authorization trace identifier.</td>
                        </tr>
                        <tr>
                          <td>postedDate</td>
                          <td>String</td>
                          <td className="text-start">Posted date.</td>
                        </tr>
                        <tr>
                          <td>postControlNumber</td>
                          <td>String</td>
                          <td className="text-start">Post control number.</td>
                        </tr>
                        <tr>
                          <td>Card</td>
                          <td>object</td>
                          <td className="text-start">Card object used in transaction.</td>
                        </tr>
                        <tr>
                          <td>employeeNumber</td>
                          <td>String</td>
                          <td className="text-start">Employee number assigned to card.</td>
                        </tr>
                        <tr>
                          <td>id</td>
                          <td>String</td>
                          <td className="text-start">Card ID.</td>
                        </tr>
                        <tr>
                          <td>cardHolderFirstName</td>
                          <td>String</td>
                          <td className="text-start">Cardholder first name.</td>
                        </tr>
                        <tr>
                          <td>cardHolderLastName</td>
                          <td>string</td>
                          <td className="text-start">Cardholder last name.</td>
                        </tr>
                        <tr>
                          <td>cardLastFour</td>
                          <td>String</td>
                          <td className="text-start">Last four digits of the card.</td>
                        </tr>
                        <tr>
                          <td>bin</td>
                          <td>String</td>
                          <td className="text-start">Bank identification number.</td>
                        </tr>
                        <tr>
                          <td>userDefinedFields</td>
                          <td>Array</td>
                          <td className="text-start">User-defined fields, if supplied.</td>
                        </tr>
                        <tr>
                          <td>Merchant</td>
                          <td>object</td>
                          <td className="text-start">Merchant object used for transaction.</td>
                        </tr>
                        <tr>
                          <td>Name</td>
                          <td>string</td>
                          <td className="text-start">Merchant name.</td>
                        </tr>
                        <tr>
                          <td>Mcc</td>
                          <td>String</td>
                          <td className="text-start">4-digit MCC number for merchant.</td>
                        </tr>
                        <tr>
                          <td>Address</td>
                          <td>object</td>
                          <td className="text-start">Merchant address object.</td>
                        </tr>
                        <tr>
                          <td>addressLine1</td>
                          <td>String</td>
                          <td className="text-start">Merchant address line 1.</td>
                        </tr>
                        <tr>
                          <td>addressLine2</td>
                          <td>string</td>
                          <td className="text-start">Merchant address line 2.</td>
                        </tr>
                        <tr>
                          <td>City</td>
                          <td>string</td>
                          <td className="text-start">Merchant city.</td>
                        </tr>
                        <tr>
                          <td>State</td>
                          <td>String</td>
                          <td className="text-start">Merchant state.</td>
                        </tr>
                        <tr>
                          <td>Country</td>
                          <td>String</td>
                          <td className="text-start">Merchant country.</td>
                        </tr>
                        <tr>
                          <td>zip</td>
                          <td>String</td>
                          <td className="text-start">Merchant ZIP/postal code.</td>
                        </tr>
                        <tr>
                          <td>POS</td>
                          <td>Object</td>
                          <td className="text-start">Point of sale object based on transaction.</td>
                        </tr>
                        <tr>
                          <td>acceptorId</td>
                          <td>string</td>
                          <td className="text-start">ID of point of sale.</td>
                        </tr>
                        <tr>
                          <td>acceptorLocation</td>
                          <td>string</td>
                          <td className="text-start">Location of point of sale.</td>
                        </tr>
                        <tr>
                          <td>entryType</td>
                          <td>integer</td>
                          <td className="text-start">POS entry type.</td>
                        </tr>
                        <tr>
                          <td>entryDescription</td>
                          <td>string</td>
                          <td className="text-start">POS entry description.</td>
                        </tr>
                        <tr>
                          <td>promptId</td>
                          <td>string</td>
                          <td className="text-start">Prompt ID, if supplied.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className='api-menu-item-title'>
                  <h2>Sample Transaction Payload</h2>
                </div>
                <p>The following sample has been updated with the provided transaction payload and token value.</p>

                <div className="api-table">
                  {/* <div className="example-box-wrapper">
                  <div className="d-flex align-items-start">
                    <b></b>
                    <p><span>Sample 1:</span></p>
                  </div>
                  <div className="example-box">
                    <div className="example-box-top">
                      <div className="tooltip1" id="myTooltip1">
                        <span className="tooltiptext">Copied</span>
                      </div>
                      <CopyToClipboard onCopy={ () => onCopy( 1 ) } text={ exampleCodeText_1 }>
                        <FontAwesomeIcon icon={ faCopy } />
                      </CopyToClipboard>
                      <FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } />
                    </div>
                    <div className="ex-text-box bighgt" id="ExampleCodeText_1">
                      <pre>{ exampleCodeText_1 }</pre>
                    </div>
                  </div>
                </div>

                <div className="example-box-wrapper">
                  <div className="d-flex align-items-start">
                    <b></b>
                    <p><span>Sample 2:</span></p>
                  </div>
                  <div className="example-box">
                    <div className="example-box-top">
                      <div className="tooltip1" id="myTooltip2">
                        <span className="tooltiptext">Copied</span>
                      </div>
                      <CopyToClipboard onCopy={ () => onCopy( 2 ) } text={ exampleCodeText_2 }>
                        <FontAwesomeIcon icon={ faCopy } />
                      </CopyToClipboard>
                      <FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } />
                    </div>
                    <div className="ex-text-box bighgt" id="ExampleCodeText_2">
                      <pre>{ exampleCodeText_2 }</pre>
                    </div>
                  </div>
                </div>

                <div className="example-box-wrapper">
                  <div className="d-flex align-items-start">
                    <b></b>
                    <p><span>Sample 3:</span></p>
                  </div>
                  <div className="example-box">
                    <div className="example-box-top">
                      <div className="tooltip1" id="myTooltip3">
                        <span className="tooltiptext">Copied</span>
                      </div>
                      <CopyToClipboard onCopy={ () => onCopy( 3 ) } text={ exampleCodeText_3 }>
                        <FontAwesomeIcon icon={ faCopy } />
                      </CopyToClipboard>
                      <FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } />
                    </div>
                    <div className="ex-text-box bighgt" id="ExampleCodeText_3">
                      <pre>{ exampleCodeText_3 }</pre>
                    </div>
                  </div>
                </div>

                <div className="example-box-wrapper">
                  <div className="d-flex align-items-start">
                    <b></b>
                    <p><span>Sample 4:</span></p>
                  </div>
                  <div className="example-box">
                    <div className="example-box-top">
                      <div className="tooltip1" id="myTooltip4">
                        <span className="tooltiptext">Copied</span>
                      </div>
                      <CopyToClipboard onCopy={ () => onCopy( 4 ) } text={ exampleCodeText_4 }>
                        <FontAwesomeIcon icon={ faCopy } />
                      </CopyToClipboard>
                      <FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } />
                    </div>
                    <div className="ex-text-box bighgt" id="ExampleCodeText_4">
                      <pre>{ exampleCodeText_4 }</pre>
                    </div>
                  </div>
                </div>

                <div className="example-box-wrapper">
                  <div className="d-flex align-items-start">
                    <b></b>
                    <p><span>Sample 5:</span></p>
                  </div>
                  <div className="example-box">
                    <div className="example-box-top">
                      <div className="tooltip1" id="myTooltip5">
                        <span className="tooltiptext">Copied</span>
                      </div>
                      <CopyToClipboard onCopy={ () => onCopy( 5 ) } text={ exampleCodeText_5 }>
                        <FontAwesomeIcon icon={ faCopy } />
                      </CopyToClipboard>
                      <FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } />
                    </div>
                    <div className="ex-text-box bighgt" id="ExampleCodeText_5">
                      <pre>{ exampleCodeText_5 }</pre>
                    </div>
                  </div>
                </div> */}

                  <div className="example-box-wrapper">
                    <div className="d-flex align-items-start">
                      <b></b>
                      <p><span>Sample:</span></p>
                    </div>
                    <div className="example-box">
                      <div className="example-box-top">
                        <div className="tooltip1" id="myTooltip6">
                          <span className="tooltiptext">Copied</span>
                        </div>
                        <CopyToClipboard onCopy={ () => onCopy( 6 ) } text={ exampleCodeText_6 }>
                          <FontAwesomeIcon icon={ faCopy } />
                        </CopyToClipboard>
                        <a onClick={ () => setShowSix( true ) }><FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } /></a>
                      </div>
                      <div className="ex-text-box bighgt" id="ExampleCodeText_6">
                        <pre>{ exampleCodeText_6 }</pre>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="api-menu-item-wrapper mt-60">
                  <h3>Token Processing Note</h3>
                  <hr />
                  <p><b>Important:</b> The token value in the payload is encrypted/signed as per the agreed key-pair flow. The corresponding public key must be used by the receiving party for token processing/validation, as confirmed in the implementation discussion.</p>
                  <h5>Reference implementation discussion:</h5>
                  <div className="table-responsive mb-20">
                    <table summary="Token processing reference notes." className="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={ { width: '220px' } }>Item</th>
                          <th style={ { width: '560px' } }>Content / Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Token source values</td>
                          <td>username | card.ID | creationTime</td>
                        </tr>
                        <tr>
                          <td>Encryption / key note</td>
                          <td>The value has been encrypted with the private key value. The corresponding public key must be used to decrypt the token value, as per the shared implementation note.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <img src={ `${ config.siteBaseUrl }/assets/imgs/blue-lowerdots.svg` } alt="" className="orng-dots" />
        <ScrollToTop smooth />
      </section>

      <Modal className='integrations-modal' show={ showSix }
        onHide={ () => setShowSix( false ) } centered
        aria-labelledby="example-modal-sizes-title-md">
        <Modal.Body>
          <Modal.Header closeButton>
          </Modal.Header>
          <div className='example-box-wrapper'>
            <div className="example-box">
              <div className="example-box-top">
                <div className="tooltip1" id="myTooltip6">
                  <span className="tooltiptext">Copied</span>
                </div>
                <CopyToClipboard onCopy={ () => onCopy( 6 ) } text={ exampleCodeText_6 }>
                  <FontAwesomeIcon icon={ faCopy } />
                </CopyToClipboard>
              </div>
              <div className="ex-text-box">
                <pre>{ exampleCodeText_6 }</pre>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
